// extracted by mini-css-extract-plugin
export default {"FavoritesPage":"FavoritesPage_FavoritesPage__qwqSJ"};